export default {"src":"/_next/static/media/GS-Icon-Calender.e32ec279.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};